import React, { PureComponent } from "react";
import axios from "axios";
import Header from "../components/Header";
import { server } from "../env";

export default class FAQs extends PureComponent {
  state = {
    faqs: [],
  };

  componentDidMount = () => {
    document.title = "Frequently Asked Questions - Proxies.gg";
    this.readFAQs();
  };

  readFAQs = async () => {
    await axios.get(server + "/v1/faq/read").then((rsp) => {
      this.setState({
        faqs: rsp.data.payload,
        backupFaqs: rsp.data.payload,
      });
    });
  };

  render() {
    const { faqs } = this.state;
    return (
      <div className="main-content">
        <Header pretitle="Dashboard" title="FAQs" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-header-title">
                    Frequently Asked Questions
                  </h4>
                </div>
                <div className="card-body">
                  <div className="accordion" id="accordionFlushExample">
                    {faqs.map((faq, index) => (
                      <div className="accordion-item lift" key={index}>
                        <h2 className="accordion-header" id={"head" + index}>
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={"#col" + index}
                            aria-expanded="false"
                            aria-controls={"col" + index}
                          >
                            {faq.question}
                          </button>
                        </h2>
                        <div
                          id={"col" + index}
                          className="accordion-collapse collapse"
                          aria-labelledby={"head" + index}
                          data-bs-parent="#accordionFlushExample"
                        >
                          <div className="accordion-body">{faq.answer}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
